// Sizes for the desktop sidebar that the theme's spacing scale doesn't cover.

export const SIDEBAR_WIDTH_EXPANDED = 240;
export const SIDEBAR_WIDTH_COLLAPSED = 72;
export const SIDEBAR_TRANSITION = '200ms ease-in-out';

export const SIDEBAR_ITEM_HEIGHT = '48px';
export const SIDEBAR_ITEM_RADIUS = '12px';
export const SIDEBAR_ICON_SIZE = 24;
export const SIDEBAR_AVATAR_SIZE = 22;

export const SIDEBAR_TOGGLE_SIZE = '40px';
export const SIDEBAR_TOGGLE_RADIUS = '10px';

export const SIDEBAR_LOGO_WIDTH = 96;
export const SIDEBAR_LOGO_HEIGHT = 28;

export const SIDEBAR_BADGE_SIZE = '18px';
export const SIDEBAR_BADGE_TOP = '-6px';
export const SIDEBAR_BADGE_RIGHT = '-10px';
